import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import { Text } from "../styledComponents";
import { colorsPalettes, fonts, rgba } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { i18nFilter } from "app/filters/i18nFilter";
import type React from "react";
import type { INavigationTileProps } from "app/pages/digital-marketing/home-pages/MajorNavigationTile";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const BoxStyled = styled(Box)<{ $height?: number }>`
    width: 100%;
    height: ${({ $height = 158 }) => `${$height}px`};
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
        outline: 1px solid ${colorsPalettes.carbon[100]};
        box-shadow: 0 3px 5px ${rgba(colorsPalettes.carbon[400], 0.12)};
    }
`;

const TileContent = styled(CenteredFlexColumn)`
    padding: 16px;
`;

const SWReactIconsStyled = styled(SWReactIcons)`
    margin-bottom: 16px;
`;

const Title = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[500],
}))`
    ${(props) =>
        setFont({
            $size: 16,
            $weight: "500",
            $color: props.color,
            $family: fonts.$dmSansFontFamily,
        })};
    display: flex;
    text-transform: capitalize;
    margin-bottom: 4px;
`;

const SubTitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[300],
}))`
    font-size: 14px;
`;

export const MajorNavigationTile: React.FC<INavigationTileProps> = ({
    iconName,
    title,
    subTitle,
    navigationState,
    id,
    useRedirect = false,
    guid = "dmi-homepage.tile.click",
    boxHeight,
    CtaComponent,
    onTileClick,
}) => {
    const i18n = i18nFilter();

    const handleNavigation = () => {
        const itemName = i18n(title) || "";
        const eventName = guid === "after-trial-homepage.tile.click" ? `free tool card/homepage/${itemName}` : itemName;
        allTrackers.dispatchTrackEvent("Internal Link", "click", eventName);
        if (useRedirect) {
            proNavigator.go("competitionRedirect", { id });
        } else {
            proNavigator.go(navigationState);
        }
    };

    return (
        <BoxStyled
            onClick={onTileClick ? () => onTileClick(title) : handleNavigation}
            $height={boxHeight}
        >
            <TileContent>
                <SWReactIconsStyled
                    iconName={iconName}
                    size="xl"
                />
                <Title>{i18n(title)}</Title>
                <SubTitle>{i18n(subTitle)}</SubTitle>
            </TileContent>
            {CtaComponent}
        </BoxStyled>
    );
};
